// @noflow
import { getRangeColours } from '~/core/utils/colour';
import PropTypes from 'prop-types';
import * as React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import Spinner from '../../spinner/spinner.component';
import { SpinnerContainer } from './styles';

const DEFAULT_FONT = 'Bariol, Arial, sans-serif';

/************************
 *   Helper functions   *
 ************************/

const _defineRangeValues = (maxTemp, minTemp, interval, frostProtection, intl) => {
    const rangeValues = [];
    for (let i = maxTemp; i >= minTemp; i -= interval) {
        if (i === frostProtection) {
            rangeValues.push([
                { text: `${intl.formatNumber(i)}`, coef: 1 },
                { text: 'N', coef: 0.7, font: 'HiveGeneralIcons' }
            ]);
        } else {
            rangeValues.push([{ text: `${intl.formatNumber(i)}°`, coef: 1 }]);
        }
    }
    return rangeValues;
};

const _getCurrentIndex = (maxTemp, minTemp, interval, currentValue) => {
    const temp = currentValue ? Math.max(Math.min(currentValue, maxTemp), minTemp) : minTemp;
    return Math.round((maxTemp - temp) / interval);
};

const _getTemperature = (maxTemp, interval, index) => maxTemp - index * interval;

/*****************
 *   Component   *
 *****************/

class TemperatureSpinner extends React.Component {
    static propTypes = {
        currentTemp: PropTypes.number,
        frostProtectionValue: PropTypes.number,
        handleChangeTemp: PropTypes.func,
        interval: PropTypes.number,
        intl: intlShape,
        maxTemp: PropTypes.number.isRequired,
        minTemp: PropTypes.number.isRequired
    };

    static defaultProps = {
        interval: 1
    };

    constructor(props) {
        super(props);

        const { currentTemp, interval, maxTemp, minTemp, frostProtectionValue, intl } = props;

        const rangeValues = _defineRangeValues(maxTemp, minTemp, interval, frostProtectionValue, intl);
        const rangeColors = getRangeColours(maxTemp, minTemp, interval);
        const currentIndex = _getCurrentIndex(maxTemp, minTemp, interval, currentTemp);

        this.state = {
            currentIndex,
            rangeColors,
            rangeValues
        };
    }

    componentWillUpdate(nextProps) {
        const { currentTemp, interval, maxTemp, minTemp } = nextProps;

        if (currentTemp !== this.props.currentTemp) {
            const currentIndex = _getCurrentIndex(maxTemp, minTemp, interval, currentTemp);
            this.setState({ currentIndex });
        }
    }

    handleChangeIndex = newIndex => {
        const { handleChangeTemp, interval, maxTemp } = this.props;

        const newTemperature = _getTemperature(maxTemp, interval, newIndex);
        handleChangeTemp(newTemperature);

        this.setState({
            currentIndex: newIndex
        });
    };

    render() {
        const { currentIndex, rangeColors, rangeValues } = this.state;

        return (
            <SpinnerContainer>
                <Spinner
                    currentIndex={currentIndex}
                    font={DEFAULT_FONT}
                    handleChangeIndex={this.handleChangeIndex}
                    rangeColors={rangeColors}
                    rangeValues={rangeValues}
                    style={{
                        borderRadius: '100%',
                        height: '100%',
                        position: 'absolute',
                        width: '100%'
                    }}
                />
            </SpinnerContainer>
        );
    }
}

export default injectIntl(TemperatureSpinner);



// WEBPACK FOOTER //
// ./src/components/widgets/temperature-spinner/full-color-range/index.js